import { makeStyles } from '@material-ui/core/styles'
import { Button } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { useEffect, useState } from 'react'
import {
  fetchTokenForBuyPolicy,
  getFormattedMedicalQuestions,
  getHealthKycRequestBody,
  getMedicalQuestions,
  saveISNPStatus,
  verifyKYC,
} from 'src/services/buyPolicyService'
import LoadingModal from 'src/components/common/LoadingModal'
import { useDispatch, useSelector } from 'react-redux'
import {
  showNotificationMessage,
  updateMemberDetails,
  updateProposerDetails,
} from 'src/actions'
import { getFullName, scrollToTop } from 'src/utils/commonMethods'
import arrow from 'src/assets/Buy_Policy_Images/arrow.svg'
import {
  ANSWER_TYPES,
  cKYC_LIST,
  CURRENT_STATUS,
  ENCOUNTERED_ERROR_WHILE_SAVING,
  ERROR_ON_KYC,
  INSURANCE_TYPE_CATOGORIES,
  RELATION_TYPE_ENUMS,
} from 'src/utils/constants/BuyPolicy'
import DynamicAnswerControl from 'src/components/BuyPolicy/common/DynamicAnswerControl'
import { getTokenForQrReport } from 'src/services/individualService'
import { COLORS } from 'src/utils/Themes/colors'
import TeleConsultationModal from 'src/components/BuyPolicy/insuranceScreens/health/TeleConsultationModal'
import Modal from '@mui/material/Modal'
import VerifyKycModal from 'src/components/BuyPolicy/modals/VerifyKycModal'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { getISNPStatusRequestBody } from 'src/utils/commonMethods/buyPolicy'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'
import {
  CONTINUE,
  ENCOUNTERED_MEDICAL_QUESTIONS,
  FAILURE,
  NEXT,
} from 'src/utils/constants/Health'

const MedicalCondition = () => {
  const classes = useStyles()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const guestUserDetails = useSelector((state) => state?.buyPolicyReducer)
  const [memberDetails, setMemberDetails] = useState(
    guestUserDetails?.memberDetails
  )
  const [memberDetailsIndex, setMemberDetailsIndex] = useState(0)
  const providerId = guestUserDetails?.selectedQuote?.providerId
  const currentMember = memberDetails[memberDetailsIndex] ?? {}
  const proposerDetails = guestUserDetails?.proposerDetails
  const [showTeleConsultation, setShowTeleConsultation] = useState(false)
  const [openKYC, seOpenKYC] = useState(false)

  const dispatch = useDispatch()

  useEffect(() => {
    scrollToTop()
    if (currentMember && !currentMember?.medicalQuestionnaire?.length) {
      fetchToken()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchToken = async () => {
    setLoading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)

      const token = response?.res?.data?.access_token
      fetchMedicalQuestions(token)
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }

  const setMemberMedicalQuestionnaire = (medicalQuestionsData) => {
    const memberDetailsList = guestUserDetails?.memberDetails
    memberDetailsList?.forEach((member) => {
      member['medicalQuestionnaire'] = JSON.parse(
        JSON.stringify(getFormattedMedicalQuestions(medicalQuestionsData))
      )
    })
    dispatch(updateMemberDetails(memberDetailsList))
  }

  const fetchMedicalQuestions = async (token) => {
    setLoading(true)
    const response = await getMedicalQuestions(token, providerId)
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      if (responseData?.success) {
        setMemberMedicalQuestionnaire(responseData?.medicalQuestionnaire)
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: ENCOUNTERED_MEDICAL_QUESTIONS,
        })
      )
    }
  }

  const saveMetadataAndNavigate = () => {
    setLoading(true)

    fetchTokenForBuyPolicy()
      .then((token) => {
        setLoading(false)
        saveISNPStatusTasks(token)
      })
      .catch(() => {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
          })
        )
      })
  }

  const saveISNPStatusTasks = async (token) => {
    setLoading(true)
    const formData = getISNPStatusRequestBody(
      guestUserDetails,
      INSURANCE_TYPE_CATOGORIES?.health,
      CURRENT_STATUS?.detailsFilled
    )

    saveISNPStatus(token, formData)
      .then((response) => {
        return response?.res?.data
      })
      .then(() => {
        setLoading(false)
        history.push(
          '/individual/dashboard/buyPolicy/health/insuranceDetails/terms-and-conditions'
        )
      })
      .catch(() => {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: ENCOUNTERED_ERROR_WHILE_SAVING,
          })
        )
      })
  }

  const handleBack = () => {
    dispatch(updateMemberDetails(memberDetails))
    if (memberDetailsIndex === 0) {
      history.push(
        '/individual/dashboard/buyPolicy/health/insuranceDetails/member-details'
      )
    } else {
      scrollToTop()
      setMemberDetailsIndex(memberDetailsIndex - 1)
    }
  }
  const handleContinue = async () => {
    dispatch(updateMemberDetails(memberDetails))
    if (memberDetailsIndex === memberDetails?.length - 1) {
      if (isAnyQuestionChecked(memberDetails)) {
        setShowTeleConsultation(true)
      } else {
        if (cKYC_LIST?.includes(guestUserDetails?.selectedQuote?.providerId)) {
          seOpenKYC(true)
        } else {
          saveMetadataAndNavigate()
        }
      }
    } else {
      scrollToTop()
      setMemberDetailsIndex(memberDetailsIndex + 1)
    }
  }
  const showSubQuestions = (question) => {
    return (
      question.answerType === ANSWER_TYPES?.BOOLEAN &&
      question?.isApplicable &&
      question?.subQuestions
    )
  }
  const handleMainQuestionChange = (questionIndex, answer) => {
    const memberDetailsList = [...memberDetails]
    if (
      memberDetailsList?.[memberDetailsIndex]?.medicalQuestionnaire?.[
        questionIndex
      ]?.answerType === ANSWER_TYPES?.BOOLEAN
    ) {
      memberDetailsList[memberDetailsIndex].medicalQuestionnaire[
        questionIndex
      ].isApplicable = answer
      if (
        memberDetailsList?.[memberDetailsIndex]?.medicalQuestionnaire?.[
          questionIndex
        ]?.subQuestions
      ) {
        memberDetailsList?.[memberDetailsIndex]?.medicalQuestionnaire?.[
          questionIndex
        ]?.subQuestions?.forEach(() => {
          //  subQuestion.isApplicable = answer;
        })
      }
    } else {
      memberDetailsList[memberDetailsIndex].medicalQuestionnaire[
        questionIndex
      ].detailAnswer = answer
    }
    setMemberDetails(memberDetailsList)
  }

  const handleSubQuestionChange = (
    mainQuestionIndex,
    subQuestionIndex,
    answer
  ) => {
    const memberDetailsList = [...memberDetails]
    if (
      memberDetailsList?.[memberDetailsIndex]?.medicalQuestionnaire?.[
        mainQuestionIndex
      ]?.subQuestions?.[subQuestionIndex]?.answerType === ANSWER_TYPES?.BOOLEAN
    ) {
      memberDetailsList[memberDetailsIndex].medicalQuestionnaire[
        mainQuestionIndex
      ].subQuestions[subQuestionIndex].isApplicable = answer
    } else {
      memberDetailsList[memberDetailsIndex].medicalQuestionnaire[
        mainQuestionIndex
      ].subQuestions[subQuestionIndex].detailAnswer = answer
    }
    setMemberDetails(memberDetailsList)
  }

  const getContinueButtonText = () => {
    if (memberDetailsIndex === memberDetails?.length - 1) {
      return CONTINUE
    }
    return NEXT
  }

  const getCurrentMemberName = () => {
    if (currentMember?.relation === RELATION_TYPE_ENUMS?.SELF) {
      return getFullName([
        proposerDetails?.firstName,
        proposerDetails?.lastName,
      ])
    } else {
      return getFullName([currentMember?.firstName, currentMember?.lastName])
    }
  }

  const isAnyQuestionChecked = (memberDetails) => {
    for (const member of memberDetails) {
      if (
        member?.medicalQuestionnaire?.some((question) => question?.isApplicable)
      ) {
        return true
      }
    }
    return false
  }

  const handleClose = () => {
    setShowTeleConsultation(false)
    setLoading(true)
    window.location.reload()
  }
  const closeModal = () => {
    seOpenKYC(false)
  }

  const fetchKYCStatus = async (token, proposerKYCDetails) => {
    const proposerDetails = {
      ...guestUserDetails?.proposerDetails,
      panNumber: proposerKYCDetails?.panNumber?.value,
      dateOfBirth: proposerKYCDetails?.dateOfBirth?.value,
    }

    const updatedGuestUserDetails = {
      ...guestUserDetails,
      proposerDetails: proposerDetails,
    }
    setLoading(true)
    const formData = getHealthKycRequestBody(updatedGuestUserDetails)
    const response = await verifyKYC(token, formData)

    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      dispatch(updateProposerDetails(proposerDetails))
      if (responseData?.statusMessage !== FAILURE) {
        history.push(
          '/individual/dashboard/buyPolicy/health/insuranceDetails/terms-and-conditions'
        )
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData.message,
          })
        )
        window.open(responseData?.il_kyc_url, '_self')
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: ERROR_ON_KYC,
        })
      )
    }
  }

  return (
    <>
      {openKYC ? (
        <Modal id='modal' open={openKYC} onClose={closeModal}>
          <div className={'modal-container'}>
            <VerifyKycModal
              closeModal={closeModal}
              verifyKYCFunction={fetchKYCStatus}
              pan={guestUserDetails?.proposerDetails?.panNumber}
              dateOfBirth={guestUserDetails?.proposerDetails?.dateOfBirth}
              quoteDetails={guestUserDetails?.selectedQuote}
            />
          </div>
        </Modal>
      ) : null}
      <LoadingModal loading={loading} />
      {showTeleConsultation ? (
        <Modal open={showTeleConsultation} onClose={handleClose} id='modal'>
          <div className={`${classes.modalRoot} modal-container`}>
            <TeleConsultationModal
              open={showTeleConsultation}
              onClose={handleClose}
              proposerDetails={proposerDetails}
              memberDetails={memberDetails}
              selectedQuote={guestUserDetails?.selectedQuote}
            />
          </div>
        </Modal>
      ) : null}

      {openKYC ? (
        <Modal id='verifyKycModal' open={openKYC} onClose={closeModal}>
          <div className={'modal-container'}>
            <VerifyKycModal
              closeModal={closeModal}
              verifyKYCFunction={fetchKYCStatus}
              pan={guestUserDetails?.proposerDetails?.panNumber}
              dateOfBirth={guestUserDetails?.proposerDetails?.dateOfBirth}
              quoteDetails={guestUserDetails?.selectedQuote}
            />
          </div>
        </Modal>
      ) : null}

      <div className={classes.mainContainer}>
        <div>
          <div onClick={handleBack} className={classes.goBackButtonContainer}>
            <img src={arrow} alt='arrow' />
            <span className={classes.gotoBackButton}>Go back</span>
          </div>
        </div>

        <span className={classes.title}>
          Are there any pre-existing medical condition for&nbsp;
          <span className={classes.relationType}>{getCurrentMemberName()}</span>
          &nbsp;?
        </span>
        <span className={classes.preExistingDiseaseNote}>
          *Accuracy in health information is crucial for successful claims.
        </span>
        {currentMember?.medicalQuestionnaire &&
        currentMember?.medicalQuestionnaire?.length > 0
          ? currentMember?.medicalQuestionnaire?.map((question, index) => {
              return (
                <div
                  className={classes.container}
                  key={`medicalQuestion_${currentMember?.id}_${question?.questionCode}`}
                >
                  <div
                    className={`${classes.medicalItemContainer} ${
                      question?.answerType === ANSWER_TYPES?.TEXT_DESCRIPTION
                        ? classes.questionColumn
                        : null
                    }`}
                  >
                    <div className={classes.medicalItem}>
                      <span className={classes.item}>
                        {question?.medicalQuestion}
                      </span>
                    </div>
                    <div
                      className={`${classes.medicalImage} ${
                        question?.answerType === ANSWER_TYPES?.TEXT_DESCRIPTION
                          ? classes.medicalImageColumn
                          : null
                      }`}
                    >
                      <DynamicAnswerControl
                        question={question}
                        id='mainQuestion'
                        onChange={(value) =>
                          handleMainQuestionChange(index, value)
                        }
                      />
                    </div>
                  </div>
                  {showSubQuestions(question) && (
                    <div className={classes.subQuestionDiv}>
                      {question?.subQuestions?.map(
                        (subQuestionItem, subQuestionIndex) => {
                          return (
                            <div
                              className={classes.subQuestionItemDiv}
                              key={`subQuestion_${currentMember?.id}_${subQuestionItem?.questionCode}`}
                            >
                              <div
                                className={`${classes.medicalItemContainer} ${
                                  subQuestionItem?.answerType ===
                                  ANSWER_TYPES?.TEXT_DESCRIPTION
                                    ? classes.questionColumn
                                    : null
                                }`}
                              >
                                <div className={classes.medicalItem}>
                                  <span className={classes.item}>
                                    {subQuestionItem?.medicalQuestion}
                                  </span>
                                </div>
                                <div
                                  className={`${classes.medicalImage} ${
                                    subQuestionItem?.answerType ===
                                    ANSWER_TYPES?.TEXT_DESCRIPTION
                                      ? classes.medicalImageColumn
                                      : null
                                  }`}
                                >
                                  <DynamicAnswerControl
                                    question={subQuestionItem}
                                    id='subQuestion'
                                    onChange={(value) =>
                                      handleSubQuestionChange(
                                        index,
                                        subQuestionIndex,
                                        value
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          )
                        }
                      )}
                    </div>
                  )}
                  <div>
                    <hr className={classes.hr} />
                  </div>
                </div>
              )
            })
          : null}

        <div className={classes.buttonsContainer}>
          <div>
            <Button
              type={'button'}
              onClick={handleBack}
              className={classes.backButton}
              id='backButton'
            >
              Back
            </Button>
          </div>
          <div>
            <Button
              type={'button'}
              onClick={handleContinue}
              className={classes.continueButton}
              id='submitButton'
            >
              {getContinueButtonText()}
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default MedicalCondition

const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    width: '100%',
  },
  title: {
    fontFamily: 'Roboto',
    fontSize: '18px',
    color: '#24A8CC',
    marginBottom: '20px',
    fontWeight: 'bold !important',
  },
  medicalImageColumn: {
    width: '100% !important',
  },
  medicalImage: {
    flex: '1',
    textAlign: 'end',
    width: '20%',
  },
  containerItem: {
    display: 'flex',
    marginBottom: '10px',
  },
  itemContent: {
    width: '80%',
    marginTop: '15px',
  },
  item: {
    fontFamily: 'Roboto',
    fontSize: '14px',
  },
  medicalItem: {
    padding: '10px 0px 0px 0px',
    width: '80%',
  },
  hr: {
    border: '1px solid #D1D1D1',
    marginBottom: '20px',
    marginTop: '20px',
    '&:last-child': {
      border: 0,
      display: 'none',
    },
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '40px',
  },
  backButton: {
    color: '#28A6C8 !important',
    fontFamily: 'Roboto !important',
    fontSize: '16px !important',
    cursor: 'pointer !important',
    width: '130px',
    border: '1px !important',
    padding: '10px !important',
    borderRadius: '10px !important',
    background: '#E4EFF2 !important',
    textTransform: 'none !important',
    fontWeight: 'bold !important',
  },
  continueButton: {
    fontFamily: 'Roboto !important',
    fontSize: '16px !important',
    color: 'white !important',
    background: 'linear-gradient(#4EC4E4 100%, #0288AC 100% ) !important',
    cursor: 'pointer !important',
    width: '130px',
    border: '1px !important',
    padding: '10px !important',
    borderRadius: '10px !important',
    marginLeft: '15px !important',
    textTransform: 'none !important',
    fontWeight: 'bold !important',
  },
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
  },
  medicalItemContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
  },
  questionColumn: {
    flexDirection: 'column',
  },
  medicalItemContainerSubSection: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  medicalItemContainerSubSectionText: {
    width: '100%',
    justifyContent: 'space-between',
  },
  subQuestionDiv: { display: 'flex', flexDirection: 'column', padding: '5px' },
  inputContent: {
    width: '30%',
  },
  textField: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    width: '90%',
    padding: '12px 0px',
    border: '1px solid #A1A1A1',
    borderRadius: '5px',
  },
  subQuestionItemDiv: {
    display: 'flex',
    flexDirection: 'column',
    padding: '5px',
  },
  relationType: {
    fontSize: '20px',
    color: COLORS.DARK_PINK,
    textTransform: 'capitalize',
  },
  goBackButtonContainer: {
    display: 'flex',
    cursor: 'pointer',
    gap: '5px',
    marginBottom: '10px',
  },
  gotoBackButton: {
    fontSize: '12px',
    border: '1px',
    backgroundColor: 'white',
    cursor: 'pointer',
  },
  preExistingDiseaseNote: {
    fontSize: '15px',
    marginBottom: '10px',
  },
  modalRoot: {
    maxWidth: '687px',
    maxHeight: '90%',
    width: '100%',
  },
})
